import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Preloader from "../../components/Preloader";
import Input from "../../components/Input";
import Select from "../../components/Select";
import { TypesService } from "../../services/TypesService";
import { LeadService } from "../../services/LeadService";

const Registrar = ({
  token,
  user
}) => {
  const navigate = useNavigate();
  const { id, j } = useParams();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [disableVenta, setDisableVenta] = useState(true);
  const [phone, setPhone] = useState("");
  const [reportedSelected, setReportedSelected] = useState("");
  const [notes, setNotes] = useState("");
  const [statusSelected, setStatusSelected] = useState("");
  const [data, setData] = useState({});
  const [seguimiento, setSeguimiento] = useState([]);
  const [statusLead, setStatusLead] = useState([]);
  const onlyRead = typeof j != "undefined" && j && j === "only";

  const handleBackToList = () => {
    navigate("/admin/leads"); // ajusta según tu ruta de listado
  };

  const getFollowing = async () => {
    setLoading(true);
    try {
      let rStatusList = [];
      const responseStatus = await TypesService.get({
        token: token,
        table: 'estado_leads'
      });
      responseStatus.map((r) => {
        rStatusList.push({
          id: r.id,
          nombre: r.descripcion
        });
      });
      setStatusLead(rStatusList);
      const responseLead = await LeadService.getById({
        token: token,
        vid: id
      });
      console.log(responseLead);
      setData(responseLead.lead);
      setSeguimiento(responseLead.lead.seguimiento);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error al obtener la venta:", error);
    }
  };

  useEffect(() => {
    if (id) {
      getFollowing();
    }
  }, [id, token]);

  useEffect(() => {
    setDisableVenta(statusSelected != 4);
  }, [statusSelected]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await LeadService.save({
      token: token,
      formData: {
        vid: id,
        reportedSelected: reportedSelected,
        notes: notes,
        statusSelected: statusSelected,
        phone: phone,
      }
    });
    setLoading(false);
    setPhone("");
    setReportedSelected("");
    setNotes("");
    setStatusSelected("");
    getFollowing();
  };

  return (
    <div className="ventas-admin-content">
      {loading && <Preloader />}
      <div className="breadcrumb-container">
        <span className="breadcrumb-link" onClick={handleBackToList}>
          ← Listado de Leads
        </span>
        <span className="breadcrumb-current"> / Leads</span>
      </div>
      <div className="flex justify-between">
        <div className="container w-70">
          <div className="dashboard-card nueva-venta-responsive">

            <form
              className="nueva-venta-form"
              onSubmit={handleSubmit}
              autoComplete="off"
            >

              {error && <div className="error-message">{error}</div>}
              {success && <div className="success-message">{success}</div>}

                <div className="flex justify-between">
                  <Select title="Estado" value={statusSelected} setValue={setStatusSelected} options={
                    [
                      ...[
                        {
                          id: 0,
                          nombre: 'Seleccione'
                        }
                      ],
                      ...statusLead
                    ]} className="w-30" disable={onlyRead} />
                  <Select title="Contactabilidad" value={reportedSelected} setValue={setReportedSelected} options={[
                    {
                      id: 0,
                      nombre: 'Seleccione'
                    },
                    {
                      id: 1,
                      nombre: 'Contesta'
                    },
                    {
                      id: 2,
                      nombre: 'No contesta'
                    },
                  ]} className="w-30" disable={onlyRead} />
                  <Input title="Num. contactado" value={phone} setValue={setPhone} placeholder="Ingrese numero" className="w-30" disable={onlyRead} />
                </div>

                <div className="flex justify-between pt-10 items-end">
                  <Input title="Observación" value={notes} setValue={setNotes} placeholder="" className="w-65" type="textarea" disable={onlyRead}/>
                  
                  <div className="w-30">
                    {
                      user.perfil != 1 && (
                        <button
                          className="btn btn-primary w-full"
                          type="submit"
                          disabled={loading || onlyRead}
                        >
                          {loading
                            ? "Procesando..."
                              : "Registrar"
                          }
                        </button>
                      )
                    }
                  </div>
                </div>
            </form>
          </div>

          <div className="ventas-table-wrapper pt-40">
            <table className="ventas-table">
              <thead>
                <tr>
                  <th>F. Gestión</th>
                  <th>Back</th>
                  <th>Estado</th>
                  <th>Num. Contactado</th>
                  <th>Observación</th>
                  <th># Contac</th>
                </tr>
              </thead>
              <tbody>
                {
                  seguimiento.map((r, k) => (
                    <tr key={r.id}>
                      <td>{new Date(r.fecha).toLocaleDateString()}</td>
                      <td>{r.nombre_vendedor}</td>
                      <td>{r.estado}</td>
                      <td>{r.numero_contactado}</td>
                      <td>{r.observacion}</td>
                      <td>{k+1}</td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>

        </div>
        <div className="container w-30 bl-1">
          {
            typeof data.id != "undefined" && (
              <div className="container-gray">
                <p>Tipo base - {data.tipo_base} </p>
                <p>CODIGO DE VENTA</p>
                <p>TIPO DOCUMENTO - DNI</p>
                <p>NÚMERO DOCUMENTO - {data.numero_documento}</p>
                <p>NOMBRES COMPLETOS / RAZÓN SOCIAL</p>
                <p>{data.nombre} {data.apellido_paterno} {data.apellido_materno}</p>
                <p>TELÉFONO: {data.telefono_1}</p>
                <p>TELÉFONO: {data.telefono_2}</p>
                <p>TELÉFONO: {data.telefono_3}</p>
                <p>Estado - {data.estado}</p>
                {
                  true && (
                    <button
                      className="btn btn-orange"
                      type="button"
                      disabled={disableVenta ? true : loading}
                      onClick={() => navigate(`/admin/ventas/registrar/?id_lead=${id}`)}
                    >
                      V E N T A
                    </button>
                  )
                }
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default Registrar;
